/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { ListView } from 'antd-mobile'
import PageLoading from '@components/PageLoading'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
// icon
// css
import styled from '@themes/theme'
import { ChatArea } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { Schema$RecordUserAsset, Schema$RecordUserMoney } from '@protocol/bank'
import { AssetsRecordSource } from '@store/bankStore'
import MoneyHistoryListItem from '../MoneyHistoryListItem'

const MoneyHistoryWrap = styled.div`
  ${ChatArea};
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  .money-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: 42px;
    max-height: 42px;
    padding: 16px 14px;
    background: ${props => props.theme.color.contentsBg};
    &--txt {
      flex:1;
      color: ${props => props.theme.color.gray};
    }
    &--money-wrap {
      flex:3;
      &--num {
        display: inline-block;
        width: calc(100% - 14px);
        text-align: right;
      }
    }
  }
`

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => {
    return row1 !== row2
  },
})


const PAGE_SIZE = 9999

function MyBody(props: any) {
  const { children } = props
  return <div className="am-list-body my-body">{children}</div>
}

const ItemHistoryList: React.FC = () => {
  const { bankStore } = useRootStore()
  const { currentMyBankPropertyId, isLoading, historyList = {} as AssetsRecordSource } = bankStore
  const { tracks = [] } = historyList

  useOnMount(() => {
    bankStore.fetchHistoryList(PAGE_SIZE, true)
  })

  const onEndReached = async event => {
    await bankStore.fetchHistoryList(PAGE_SIZE, false)
  }

  const renderRow = (rowDataList: Schema$RecordUserAsset | Schema$RecordUserMoney) => {
    return <MoneyHistoryListItem propertyId={currentMyBankPropertyId} track={rowDataList} />
  }

  const renderFooter = () => {
    let footer
    if (isLoading) {
      footer = <PageLoading />
    } else if (tracks.length > 0) {
      footer = <Fragment />
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.ITEM_HISTORY} />
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const renderTitle = (): React.ReactElement => {
    return (
      <div className="money-row" style={{padding: '13px 14px'}}>
        <span className="money-row--txt" style={{textAlign: 'center'}}>
          최근 3일간의 내역을 확인할 수 있습니다.
        </span>
      </div>
    )
  }

  const listViewProps = {
    css: { height: '100%' },
    dataSource: dataSource.cloneWithRows(tracks),
    renderFooter,
    renderRow,
    className: 'am-list',
    pageSize: PAGE_SIZE,
    useBodyScroll: isMobile,
    renderBodyComponent: () => <MyBody />,
    scrollRenderAheadDistance: 500,
    initialListSize: PAGE_SIZE,
    onEndReached,
    onEndReachedThreshold: 10,
  }

  if (isMobile) {
    delete listViewProps.renderBodyComponent
  }

  return (
    <MoneyHistoryWrap className={!isMobile && 'pc-money-history-wrap'}>
      {renderTitle()}
      <ListView {...listViewProps} />
    </MoneyHistoryWrap>
  )
}

export default observer(ItemHistoryList)
